import { render, staticRenderFns } from "./BMW2026ChargingDisclosurei4i5iX.vue?vue&type=template&id=3a7077ea&"
import script from "./BMW2026ChargingDisclosurei4i5iX.vue?vue&type=script&lang=js&"
export * from "./BMW2026ChargingDisclosurei4i5iX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports